import React from "react";
import parser from "html-react-parser";

const LabelField = ({ label, name, required, hidden, value, ...props }) => {
  return (
    <>
      <div
        className="tps-form-question"
        style={{ display: hidden ? "none" : "" }}
      >
        <div className="tps-form-label">
          {!!label && label !== "" && (
            <label
              className={`${
                required
                  ? "tps-field-required tps-to-validate"
                  : "tps-not-required"
              }`}
            >
              {parser(label)}
            </label>
          )}
        </div>

        <div className="tps-form-input">
          <span className="LabelField form-control-text">{value}</span>
        </div>
      </div>
    </>
  );
};

export default LabelField;
